module.exports = __webpack_public_path__ + "static/media/beach1919.400724dc.png";